import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface BookingStat {
  month: string;
  bookings: number;
  occupancyRate?: number;
  averageNights?: number;
}

interface PropertyStatsProps {
  propertyId: string;
  bookingStats: BookingStat[];
  totalBookings?: number;
  averageNights?: number;
  occupancyRate?: number;
}

export default function PropertyStats({ 
  propertyId, 
  bookingStats,
  totalBookings = 0,
  averageNights = 0,
  occupancyRate = 0
}: PropertyStatsProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white p-4 rounded-lg shadow-sm">
          <h4 className="text-sm font-medium text-gray-500">Total réservations</h4>
          <p className="mt-2 text-2xl font-semibold text-gray-900">{totalBookings}</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm">
          <h4 className="text-sm font-medium text-gray-500">Nuits moyennes</h4>
          <p className="mt-2 text-2xl font-semibold text-gray-900">{averageNights.toFixed(1)}</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm">
          <h4 className="text-sm font-medium text-gray-500">Taux d'occupation</h4>
          <p className="mt-2 text-2xl font-semibold text-gray-900">{occupancyRate.toFixed(1)}%</p>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-semibold mb-4">Réservations par mois</h3>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={bookingStats}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="bookings" fill="#3B82F6" name="Réservations" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}